export const LOAD_KATEGORIEN = 'load_kategorien';
export const LOAD_EINGABEARTEN = 'load_eingabearten';
export const LOAD_PRUEFAKTIONEN = 'load_pruefaktionen';

export const LOAD_WARENEINGANGSPRUEFUNG_STATI = 'load_wareneingangspruefung_stati';
